export default "__VITE_ASSET__X7hnr6kl__"